import Vue from 'vue'

export async function getClientes(context, [access_token, busquedacliente, busquedafechanac, showload]) {
    try {
       
        if (showload){
          context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'POST',
            url: '/buscarclientes',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                busquedacliente: busquedacliente,
                busquedafechanac: busquedafechanac

            }

        })
       
        context.commit('client/setClientes', response.data, { root: true })
    } catch (e) {
    } finally {
        if (showload){
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateCliente(context, [access_token, cliente]) {
    try {
       
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/clientes/' + cliente.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                cliente: cliente,
               
            }
        })
        if (response.status == 200) {
           
            context.commit('client/actListClientes', response.data, { root: true })
            return response.data
        }
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function crearCliente(context, [access_token, cliente]) {
    try {
       
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/clientes',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
               
                cliente: cliente,
                
            }
        })
       
        return response.data
       /* if (response.status == 200) {
            context.commit('res/actListReservas', response.data, { root: true })
        }*/
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function deleteCliente(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/clientesdelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })
        
     
        if (response.status == 201) {
            context.commit('client/actDeleteListClientes', id, { root: true })
        }
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}
/*
export async function cambiarEstado(context, [access_token, id, estado_id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/cambiarestado',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
                estado_id: estado_id,
            }
        })
        
        if (response.status == 200) {
            context.commit('res/actEstadoListReservas', response.data, { root: true })
        }
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


*/






